import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';

/**
 * Blocks /app routes until Firebase Auth has a signed-in user
 * (or local VITE_USE_DEV_AUTH bypass is enabled).
 */
export const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading, isDevAuth } = useAuth();
  const location = useLocation();

  if (isDevAuth) return <>{children}</>;

  if (loading) {
    return (
      <div className="kin-auth-gate" role="status" aria-live="polite">
        <p>Checking sign-in…</p>
      </div>
    );
  }

  if (!user) {
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
  }

  return <>{children}</>;
};
